import React, { useState, useImperativeHandle, forwardRef, useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'
import { useParams, useHistory } from 'react-router-dom'
import Api from '../../../../../_helpers/Api'
import { trans } from '../../../../../_providers/Translation'
import DatePicker from '@/components/partials/Date'

//images
import docIcon from '../../../../../assets/img/icons/document.png'
import closeIcon from '../../../../../assets/img/icons/close.png'
import loader from '../../../../../assets/img/loader.svg'
import popupDefaultHeadImage from "@/assets/img/modals/icons/head.svg"
import deleteIcon from "@/assets/img/reservations/icons/delete.svg"

//modals
import SuccessModal from '../../../../modals/messages/SuccessOld'

function AddEditTodo(props, ref) {

    const inputFileRef = useRef(null)

    const initialValidations = {
        date: false,
        deadline: false,
        title: false,
        text: false,

    }

    const defaultData = {
        tags: [
            {
                employee: {}
            }
        ],
        repeat: false,
        repeat_after: 1
    }

    const [addTodo, setaddTodo] = useState({
        validations: initialValidations,
        overlay: false,
        modal: false,
        successModalBlur: false,
        successModalPopup: false,
        params: null,
        editData: defaultData,
        priorities: [],
        alarm: [],
        employees: []
    })

    const editMode = addTodo.params

    let params = useParams().id

    const history = useHistory()

    const handleCancel = e => {
        if (e) e.preventDefault()

        setaddTodo(addTodo => ({
            ...addTodo,
            modal: false,
            alarm: []
        }))

        setTimeout(() => {
            setaddTodo(addTodo => ({
                ...addTodo,
                overlay: false,
                params: null,
                editData: defaultData
            }))
        }, 50)

        document.getElementById('form').reset()

    }

    useImperativeHandle(ref, () => ({
        open: (params) => {
            setaddTodo(addTodo => ({
                ...addTodo,
                overlay: true,
                params: params,
            }))

            setTimeout(() => {
                setaddTodo(addTodo => ({
                    ...addTodo,
                    modal: true,
                }))
            }, 50)
        },
        close: () => handleCancel()
    }))

    useEffect(() => {
        Api.get('todos/priorities')
            .then(res => {
                setaddTodo(addTodo => ({
                    ...addTodo,
                    priorities: Array.isArray(res.data) ? res.data : (res.data?.data ?? []),
                }))
            })

        loadEmployees()
    }, [])

    useEffect(() => {
        if (editMode) {
            Api.get(`todos/find?id=${addTodo.params}`)
                .then(res => {
                    setaddTodo(addTodo => ({
                        ...addTodo,
                        editData: res.data,
                        alarm: res.data.alarms,
                    }))
                })
        }
    }, [addTodo.overlay])

    const handleAddTodo = e => {
        e.preventDefault()

        setaddTodo(addTodo => ({
            ...addTodo,
            validations: initialValidations,
            loading: true
        }))

        let data = new FormData(e.target)

        data.append('reservation_id', params)

        if (addTodo.editData.file) {
            data.append('file', addTodo.editData.file)
        }

        // Add employee information
        if (addTodo.editData.tags && addTodo.editData.tags[0] && addTodo.editData.tags[0].employee) {
            data.append('employee_id', addTodo.editData.tags[0].employee.id)
            if (addTodo.editData.tags[0].employee.is_partner) {
                data.append('is_partner_employee', 'true')
            }
        }

        // Add shared parameters if available
        if (props.sharedParams?.isShared && props.sharedParams?.sharedByTenantId) {
            data.append('is_shared', 'true')
            data.append('shared_by_tenant_id', props.sharedParams.sharedByTenantId)
        }

        const formDataObj = {}
        for (let [key, value] of data.entries()) {
            formDataObj[key] = value
        }

        let url = editMode ? `todos/edit` : `reservations/todos/add?reservation_id=${params}`

        if (editMode) data.append('id', addTodo.params)

        Api.post(url, data)
            .then(() => {
                setaddTodo(addTodo => ({
                    ...addTodo,
                    loading: false,
                    successModalBlur: true,
                }))
                setTimeout(() => {
                    setaddTodo(addTodo => ({
                        ...addTodo,
                        successModalPopup: true,
                    }))
                }, 300)
                props.callback()
                if (!props.noRedirect) history.push(`?tab=todo&indicator=${new Date().getTime()}`)
            })
            .catch(error => {
                let _err = error.response
                if (_err && _err.status && _err.status == 422) {
                    for (let [input, err] of Object.entries(_err.data.errors)) {
                        setaddTodo(addTodo => ({
                            ...addTodo,
                            validations: {
                                ...addTodo.validations,
                                [input]: true
                            },
                            loading: false,
                        }))
                    }
                }
            })
    }

    const handleAcceptCallback = () => {
        setaddTodo(addTodo => ({
            ...addTodo,
            successModalPopup: false,
        }))
        setTimeout(() => {
            setaddTodo(addTodo => ({
                ...addTodo,
                successModalBlur: false,
            }))
        }, 300)
        handleCancel()
    }

    const handlePriorytySelect = e => {
        let id = e.target.value

        setaddTodo(addTodo => ({
            ...addTodo,
            editData: {
                ...addTodo.editData,
                priority: {
                    ...addTodo.editData.priority,
                    id: id
                }
            }
        }))
    }

    const handleAdd = () => {

        let period = {
            id: Math.random().toString().substring(3),
            was_recently_created: true,
        }

        setaddTodo(prev => ({
            ...prev,
            alarm: prev.alarm.concat(period)
        }))

    }

    const handleRemove = id => {

        let filtered = addTodo.alarm.filter(p => {
            return Number(p.id) !== Number(id)
        })

        setaddTodo(prev => ({
            ...prev,
            alarm: filtered
        }))

    }

    const handleEditDataDateChange = (field, val) => {
        setaddTodo(prev => ({
            ...prev,
            editData: {
                ...prev.editData,
                [field]: val
            }
        }))
    }

    const handleAlarmChange = (e, i, field) => {
        const val = e.target.value

        let alarms = addTodo.alarm

        alarms[i][field] = val

        setaddTodo(prev => ({
            ...prev,
            alarm: alarms
        }))
    }

    const handleEmployeeChange = e => {
        let val = e.target.value
        let isPartner = e.target.selectedOptions[0]?.getAttribute('data-partner') === 'true'

        // Extract the actual ID (remove 'partner_' prefix if it exists)
        let actualId = isPartner && val.startsWith('partner_') ? val.replace('partner_', '') : val

        console.log('Performer selected:', {
            originalValue: val,
            actualId: actualId,
            isPartner: isPartner,
            selectedOption: e.target.selectedOptions[0],
            optionText: e.target.selectedOptions[0]?.textContent
        })

        setaddTodo(prev => ({
            ...prev,
            editData: {
                ...prev.editData,
                tags: [
                    {
                        employee: {
                            ...(prev.editData.tags?.[0]?.employee || {}),
                            id: actualId,
                            is_partner: isPartner,
                            display_value: val // Store the full value for display
                        }
                    }
                ]
            }
        }))

    }

    const loadEmployees = () => {
        let url = 'partners/employees/all?active=1&sort=name'

        Api.get(url)
            .then(res => {
                setaddTodo(prev => ({
                    ...prev,
                    employees: Array.isArray(res.data) ? res.data : (res.data?.data ?? []),
                }))
            })
    }

    const handleShowAttach = e => {
        e.preventDefault()

        inputFileRef.current.click()
    }

    const handleAttach = e => {
        let file = e.target.files[0]

        if (!file) {
            return
        }

        let url = URL.createObjectURL(file)

        setaddTodo(prev => ({
            ...prev,
            editData: {
                ...prev.editData,
                file: file,
                filename: file.name,
                file_url: url
            }
        }))

        inputFileRef.current.value = ''
    }

    const handleDetach = () => {

        if (editMode) {
            Api.post('todos/delete-file', {
                id: addTodo.params,
            }).then(res => {
                if (res.data.success) {
                    removeFile()
                }
            })
        } else {
            removeFile()
        }

    }

    const removeFile = () => {
        setaddTodo(prev => ({
            ...prev,
            editData: {
                ...prev.editData,
                file: null,
                filename: null,
            }
        }))
    }

    return ReactDOM.createPortal(
        <div className={`${addTodo.overlay ? 'visible' : ''} overlay`}>
            <SuccessModal
                mainMessage={trans('headings.success7')}
                secondaryMessage={trans('subheadings.success7')}
                blur={addTodo.successModalBlur}
                popup={addTodo.successModalPopup}
                acceptCallback={handleAcceptCallback}
            />

            <form id="form" onSubmit={handleAddTodo} className={`${addTodo.modal ? 'show' : ''} popup-primary large`}>
                {editMode || addTodo.editData ?
                    <>
                        <div className='head-new'>
                            <img src={popupDefaultHeadImage} alt="icon" />
                            <div className='texts'>
                                <h2>
                                    {editMode ? trans('headings.editTodo') : trans('headings.addTodo')}
                                </h2>
                                <p>
                                    {trans('subheadings.editTodo')}
                                </p>
                            </div>
                            <span className='close' onClick={handleCancel}>

                            </span>
                        </div>

                        <div className="scrollable" style={{ maxHeight: '70vh' }}>
                            <div className="row">
                                <div className="col">
                                    <label htmlFor="heading">
                                        {trans('labels.heading')}
                                    </label>
                                    <input
                                        className={addTodo.validations.title ? 'validate' : ''}
                                        type="text"
                                        id="heading"
                                        name="title"
                                        defaultValue={addTodo.editData && addTodo.editData.title}
                                    />
                                </div>

                                <div className="col">
                                    <label htmlFor="priority">
                                        {trans('labels.priority')}
                                    </label>
                                    <select
                                        value={addTodo.editData.priority && addTodo.editData.priority.id}
                                        id="priority"
                                        onChange={handlePriorytySelect}
                                        name="priority_id"
                                    >
                                        {addTodo.priorities.length > 0 && addTodo.priorities.map(priority =>
                                            <option key={priority.id} value={priority.id}>
                                                {priority.translation.name}
                                            </option>
                                        )}
                                    </select>
                                </div>
                            </div>

                            <div className='row'>

                                <div className="col">
                                    <label htmlFor="post-date">
                                        {trans('labels.setTo')}
                                    </label>
                                    <DatePicker
                                        withTime
                                        validate={Boolean(addTodo.validations.date)}
                                        name="date"
                                        id="post-date"
                                        date={addTodo.editData && addTodo.editData.date_ymd ? addTodo.editData.date_ymd : ''}
                                        onDateChange={date => handleEditDataDateChange('date_ymd', date || '')}
                                        fullWidth
                                    />
                                </div>

                                <div className="col">
                                    <label htmlFor="deadline">
                                        {trans('labels.deadline')}
                                    </label>
                                    <DatePicker
                                        withTime
                                        validate={Boolean(addTodo.validations.deadline)}
                                        name="deadline"
                                        id="deadline"
                                        date={addTodo.editData && addTodo.editData.deadline_ymd ? addTodo.editData.deadline_ymd : ''}
                                        onDateChange={date => handleEditDataDateChange('deadline_ymd', date || '')}
                                        fullWidth
                                    />
                                </div>

                            </div>


                            <div className='row'>
                                <div className='col'>
                                    <label>
                                        {trans('labels.contractor')}
                                    </label>

                                    <select
                                        name='employees[]'
                                        value={
                                            addTodo.editData &&
                                                Array.isArray(addTodo.editData.tags) &&
                                                addTodo.editData.tags.length > 0 &&
                                                addTodo.editData.tags[0] &&
                                                addTodo.editData.tags[0].employee
                                                ? (addTodo.editData.tags[0].employee.display_value || addTodo.editData.tags[0].employee.id)
                                                : ''
                                        }
                                        onChange={handleEmployeeChange}
                                    >
                                        <option value="">{trans('labels.select')}</option>
                                        {/*NEW:  Добавяне на партньора в списъка за да може да се дава белжка и на него*/}
                                        {/* Ако не е споделена резервация, покажи само моите служители */}
                                        {!props.reservationData?.externally_shared && !props.reservationData?.is_copy ? (
                                            addTodo.employees.map(p =>
                                                <option key={'emp-' + p.id} value={p.id}>
                                                    {p.name} {p.lastname}
                                                </option>
                                            )
                                        ) : (
                                            /* Ако е споделена резервация, покажи групирани опции */
                                            <>
                                                {/* Internal Employees */}
                                                <optgroup label={trans('tabs.employees')}>
                                                    {addTodo.employees.map(p =>
                                                        <option key={'emp-' + p.id} value={p.id}>
                                                            {p.name} {p.lastname}
                                                        </option>
                                                    )}
                                                </optgroup>

                                                {/* Partners - show the reservation performer */}
                                                {props.reservationData?.performer && (
                                                    <optgroup label={trans('labels.partners')}>
                                                        <option key={'partner-' + props.reservationData.performer.id} value={'partner_' + props.reservationData.performer.id} data-partner="true">
                                                            {props.reservationData.performer.type === 'App\\Employee' || props.reservationData.performer.type === 'App\\Models\\Employee'
                                                                ? `${props.reservationData.performer.name} ${props.reservationData.performer.lastname}`
                                                                : `${props.reservationData.performer.name}`
                                                            }
                                                        </option>
                                                    </optgroup>
                                                )}
                                            </>
                                        )}
                                    </select>

                                </div>
                            </div>


                            {addTodo.alarm.map((p, idx) => (
                                <React.Fragment key={'alarm-' + p.id}>
                                    <div className='row'>
                                        <div className="col">
                                            <label>
                                                {trans('labels.notify')}
                                            </label>
                                            <div className='row'>
                                                <input type="hidden" name="period_id[]" value={p.id} />
                                                <DatePicker
                                                    withTime
                                                    name="alarm[]"
                                                    validate={Boolean(addTodo.validations && addTodo.validations[`alarm.${idx}`])}
                                                    date={p.date_ymd || ''}
                                                    onDateChange={date => handleAlarmChange({ target: { value: date || '' } }, idx, 'date_ymd')}
                                                    fullWidth
                                                />
                                            </div>
                                        </div>
                                        <div className='col'>
                                            <label>
                                                {trans('labels.notifyVia')}
                                            </label>
                                            <select
                                                value={p.type}
                                                name='type[]'
                                                onChange={e => handleAlarmChange(e, idx, 'type')}
                                            >
                                                <option value='1'>{trans('random.systemNotification')}</option>
                                                <option value='2'>{trans('labels.email')}</option>
                                                <option value='3'>Viber/WhatsApp/SMS</option>
                                            </select>
                                        </div>
                                        <div className="col" style={{
                                            width: '40px',
                                            minWidth: '40px',
                                            paddingTop: '23px',
                                            flexShrink: 0
                                        }}>
                                            <button
                                                className="button-remove"
                                                onClick={() => handleRemove(p.id)}
                                                style={{
                                                    width: "40px",
                                                    height: "40px",
                                                    padding: 0,
                                                    minWidth: "initial",
                                                    flexShrink: 0,
                                                }}
                                            >
                                                <img
                                                    src={deleteIcon}
                                                    alt="delete"
                                                />
                                            </button>
                                        </div>
                                    </div>
                                </React.Fragment>
                            ))}

                            <div className="row">
                                <button className='button-small button-add' type="button" onClick={handleAdd}>
                                    {trans('buttons.addNotification')}
                                </button>
                            </div>

                            <div className="row">
                                <div className="col">
                                    <label htmlFor="content">
                                        {trans('labels.content')}
                                    </label>
                                    <textarea
                                        id="content"
                                        name="text"
                                        className={addTodo.validations.text ? 'validate' : ''}
                                        defaultValue={addTodo.editData && addTodo.editData.text}
                                    >

                                    </textarea>
                                </div>
                            </div>

                            {addTodo.editData.file
                                &&
                                <div
                                    className="row"
                                    style={{
                                        backgroundImage: 'linear-gradient(to right, #f1f1f1, #ffffff)',
                                        padding: "5px",
                                        borderRadius: "4px"
                                    }}
                                >
                                    <div
                                        className="col"
                                        style={{
                                            justifyContent: "center"
                                        }}
                                    >
                                        <label>
                                            <a
                                                href={addTodo.editData.file_url}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className='link'
                                                style={{
                                                    fontSize: "14px",
                                                    textDecoration: "underline"
                                                }}
                                            >
                                                {addTodo.editData.filename || 'n/a'}
                                            </a>
                                        </label>
                                    </div>

                                    <div className="col" style={{
                                        width: '40px',
                                        minWidth: '40px',
                                        flexShrink: 0
                                    }}>
                                        <button
                                            className="button-remove"
                                            onClick={handleDetach}
                                            style={{
                                                width: "40px",
                                                height: "40px",
                                                padding: 0,
                                                minWidth: "initial",
                                                flexShrink: 0,
                                            }}
                                        >
                                            <img
                                                src={deleteIcon}
                                                alt="delete"
                                            />
                                        </button>
                                    </div>
                                </div>
                            }

                            <div className='row'>
                                <button className='button-small' type="button" onClick={handleShowAttach}>
                                    {trans('buttons.uploadfile')}
                                </button>
                            </div>

                            <input ref={inputFileRef} type="file" onChange={handleAttach} hidden />

                        </div>

                        <div className="footer align-right">
                            {addTodo.loading ?
                                <img src={loader} alt="loading" />
                                :
                                <>
                                    <button onClick={handleCancel}>
                                        {trans('buttons.cancel')}
                                    </button>
                                    <button className="button-primary" type="submit">
                                        {trans('buttons.save')}
                                    </button>
                                </>
                            }
                        </div>
                    </>
                    :
                    <img src={loader} alt="loading" />
                }
            </form>
        </div>,
        document.body
    )
}

export default forwardRef(AddEditTodo)